function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, keydownProxyEl, searchFilter, tooltipData) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'child-menu-items-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
          "attrs": {
            'empty-message': `No items found`,
            'multiple': $attr(`multiple`),
            'progressive': true,
            'search-filter': searchFilter || $attr(`search-filter`),
            'sections': JSON.stringify($helpers.getMenuSections()),
          },
          "hook": {
            insert: $helpers.handleItemsMenuInsert,
          },
          "on": {
            click: ev => ev.stopPropagation(),
            clickItem: $helpers.handleItemClick,
            focusItem: $helpers.showItemDetails,
          },
          "props": {
            keydownProxyEl,
            sectionFromInputFn: $helpers.sectionFromInput,
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
          "attrs": {
            'tooltip-data': $attr(`open`) && JSON.stringify(tooltipData),
            'position-parent-selector': `mp-drop-menu`,
          },
          "on": {
            tooltipContextAction: $helpers.propagateEvent,
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;